<template>
  <!--个人中心-->
  <div class="personal-center" v-if="isLogin">
    <!--用户信息-最上面绿色-->
    <!--之后要跳转cas地址-->
    <router-link to="/personalInfo" class="my-top">
      <div class="left">
        <div class="avatar">
          <van-image :src="photoImg" :error-icon="require('../assets/img/avatar.png')"/>
        </div>
        <div class="info">
          <p>账号：{{ usersInfo.userId }}</p>
          <p>姓名：{{ usersInfo.displayName }}</p>
          <p>手机号：{{ usersInfo.mobile }}</p>
        </div>
      </div>
      <div class="right">
        <span>个人信息</span>
        <van-icon name="arrow"/>
      </div>
    </router-link>
<!--    &lt;!&ndash;当前借阅信息&ndash;&gt;-->
<!--    <div class="borrow" v-for="(value, key, index) in loanData">-->
<!--      <label>{{ key }}</label>-->
<!--      <router-link to="">-->
<!--        <div class="num">{{ value.maxLoanCount }}本</div>-->
<!--        <div class="text">最大可借</div>-->
<!--      </router-link>-->
<!--      <router-link to="">-->
<!--        <div class="num">{{ value.currentLoanCount }}本</div>-->
<!--        <div class="text">已借</div>-->
<!--      </router-link>-->
<!--    </div>-->
    <!--我的订单-->
    <div class="my-order box">
      <div class="header">
        <div class="left">
          <i class="iconfont icon-wodedingdan"></i>
          <strong>我的订单</strong>
        </div>
        <router-link to="/receivingAddress" class="right">收货地址
          <van-icon name="arrow"/>
        </router-link>
      </div>
      <div class="menu">
        <a @click.native="toBeConfirmed">
          <i class="dot" v-if="confirmNum > 0"></i>
          <i class="iconfont icon-daiqueren"></i>
          <span>待提交</span>
        </a>
        <router-link to="/allOrder">
          <i class="iconfont icon-quanbudingdan"></i>
          <span>全部订单</span>
        </router-link>
        <router-link to="/currentBorrow">
          <i class="iconfont icon-dangqianzaijie"></i>
          <span>当前在借</span>
        </router-link>
        <router-link to="/borrowHistory">
          <i class="iconfont icon-jieyuelishi"></i>
          <span>借阅历史</span>
        </router-link>
      </div>
    </div>
    <!--用户信息-->
    <div class="user-info box">
      <div class="header">
        <div class="left">
          <i class="iconfont icon-gerenzhongxin"></i>
          <strong>我的信息</strong>
        </div>
      </div>
      <p>
        <span class="left">条码号</span>
        <span class="right">{{ usersInfo.idCode }}</span>
      </p>
      <p>
        <span class="left">学院 | 单位</span>
        <span class="right">{{ usersInfo.dept }}</span>
      </p>
      <!--
      <p>
        <span class="left">读者类型</span>
        <span class="right">{{ data.userType }}</span>
      </p>
      -->
      <p>
        <span class="left">所属馆</span>
        <span class="right" v-if="reader">{{ reader.libName }}</span>
      </p>
      <p>
        <span class="left">注册时间</span>
        <span class="right">{{ usersInfo.regDate }}</span>
      </p>
      <p>
        <span class="left">失效时间</span>
        <span class="right">{{ usersInfo.expireDate }}</span>
      </p>
    </div>
    <!--退出登录-->
    <div class="signout-btn" @click="localLogout">
      <i class="iconfont icon-tuichu"></i>退出登录
    </div>
  </div>
  <!--未登录状态-->
  <!--
  <div class="not-logged-in" v-if="false">
    <div class="avatar">
      <img src="../assets/img/avatar.png">
    </div>
    <div class="login-btn" @click="localLogin">立即登录</div>
  </div>
  -->
</template>

<script>
import {defineComponent, computed, ref, watch} from "vue";
import store from '@/store';
import {getConfirmQty, getUsersInfo, getLoanData} from '@/api/users';
import {logout} from '@/api/sys';
import {useRouter} from "vue-router";
import {Toast} from 'vant';
import {doLogout, isNotEmpty} from '@/utils/util';

export default defineComponent({
  name: 'PersonalCenter',
  setup() {
    const router = useRouter();
    const reader = computed(() => {
      return store.state.reader.user;
    });
    const loanData = ref({});// 各供应商的可借已借
    const usersInfo = ref({});
    const confirmNum = ref(0);// 待确认列表数量
    const photoImg = ref('');// 用户头像
    const isLogin = ref(false);
    const onConfirmQty = () => {
      getConfirmQty()
          .then(data => {
            if (data >= 0) {
              confirmNum.value = data;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    };
    const onGetUsersInfo = () => {
      getUsersInfo()
          .then(data => {
            if (isNotEmpty(data)) {
              usersInfo.value = data;
              if (usersInfo.value.regDate) {
                usersInfo.value.regDate = usersInfo.value.regDate.substring(0, 10);
              }
              if (usersInfo.value.mobile) {
                usersInfo.value.mobile = usersInfo.value.mobile.substring(0, 3) + '****' + usersInfo.value.mobile.substring(7);
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
    };
    // 获取用户剩余可借数
    const onGetLoanData = () => {
      // getLoanData()
      //     .then(data => {
      //       loanData.value = data ?? {};
      //     })
      //     .catch((error) => {
      //       console.error(error);
      //     });
    };
    const toBeConfirmed = () => {
      if (confirmNum.value > 0) {
        router.push({path: '/toBeConfirmed'});
      } else {
        Toast({message: '没有待确认的订单'});
      }
    };
    const localLogout = () => {
      logout()
          .then(data => {
            if (data === null) {
              doLogout();
            }
          })
          .catch(err => console.error(err))
    };
    // const localLogin = () => {
    // 	let url = store.state.baseConfig['pda.start.url'] ?? store.state.config['pda.start.url'];
    // 	window.open(url + location.hash.substring(1), '_self');
    // };
    watch(
        reader, () => {
          if (isNotEmpty(reader.value)) {
            isLogin.value = true;
            onConfirmQty();
            onGetUsersInfo();
            // onGetLoanData();
            photoImg.value = store.state.config.local + '/users/photo/' + reader.value.uid;
          } else {
            isLogin.value = false;
          }
        },
        {immediate: true}
    );
    return {
      localLogout,
      reader,
      confirmNum,
      toBeConfirmed,
      usersInfo,
      photoImg,
      isLogin,
      loanData
    }
  },
});
</script>

<style scoped lang="less">
@import "../assets/css/personal-center.less";
</style>
